export default __webpack_public_path__ + "static/media/jam.539075e9.png";